import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  DirectorFetchingKeysList,
  GetDirectorOverallReport,
  GetDirectorReportEmployee
} from "../../Repository/Api";
import { NonEmptyValidation } from "../../Store/validate";
import { FinancialMonthOptions, FinancialYearOptions, IsOldReportYear, IsOldReportYearx } from "../Common/FinancialYear";
import { generateWordDocument } from "../Common/GenerateReport";
import OverallReport from "../Common/OverallReport";
import { errorMsg, successMsg } from "../Toastify";
const Directoroverallreport = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const navigate = useNavigate();

  useEffect(() => {
    getEmployeeList();
    getReportKeysList();
  }, []);

  const initialApplyState = {
    employee_ids: [],
    academic_year: [],
    months: [],
    fetching_keys: [],
  };

  const [apply, setApply] = useState(initialApplyState);
  const [validation, setValidation] = useState({});
  const [employee, setEmployee] = useState([]);
  const [report, setReport] = useState([]);
  const [appliedReport, setAppliedReport] = useState([]);
  const [download, setDownload] = useState(false)

  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getEmployeeList = async () => {
    const response = await GetDirectorReportEmployee(token);
    if (response && response.statusCode === 200) {
      let employee = response?.data?.map((label) => ({
        label: label.name,
        value: label.id,
      }));
      employee = [{ label: "All", value: "all" }, ...employee];
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const convertToTitleCase = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const getReportKeysList = async () => {
    try {
      const response = await DirectorFetchingKeysList(token);

      if (response && response.statusCode === 200) {
        const report = response?.data?.map((label, index) => ({
          label: convertToTitleCase(label),
          value: label,
          index: index,
        }));
        const reportWithAll = [...report];
        setReport(reportWithAll);
      } else {
        errorMsg(response.message);
      }
    } catch (error) {
      console.error("Error fetching report keys list:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.employee_ids = NonEmptyValidation(apply?.employee_ids);
    validate.academic_year = NonEmptyValidation(apply?.academic_year);

    if (!IsOldReportYear(apply)) {
      validate.months = NonEmptyValidation(apply?.months);
    }

    validate.fetching_keys = NonEmptyValidation(apply?.fetching_keys);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...apply,
        employee_ids: apply?.employee_ids?.map((date) => date.value),
        months: apply?.months?.map((date) => date.value),
        fetching_keys: apply?.fetching_keys?.map((date) => date.value),
      };
      const response = await GetDirectorOverallReport(Payload, token);
      if (response && response.statusCode === 200) {
        setAppliedReport(response.data);
        successMsg(response.message);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };
  useEffect(() => {
    if (download) {
      generateWordDocument(appliedReport, IsOldReportYearx(apply), apply)
    }
  }, [download])
  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-4">
                    <h6 className="labeltitle">
                      <span
                        className="arrowicon"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        ← &nbsp;
                      </span>Overall Appraisal Report</h6>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-3">
                    <label className="labeltext"> Employee Name *</label>
                    <ReactSelect
                      isMulti
                      value={apply?.employee_ids}
                      onChange={(e) => {
                        setData(e, "employee_ids");
                      }}
                      options={
                        apply?.employee_ids?.some((v) => v?.value === "all")
                          ? [{ label: "All", value: "all" }]
                          : employee
                      }
                    />
                    <small className="validationerror">
                      {validation?.employee_ids?.message
                        ? `Employee ${validation?.employee_ids?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Report Topics *</label>
                    <ReactSelect
                      isMulti
                      value={apply?.fetching_keys}
                      onChange={(e) => {
                        setData(e, "fetching_keys");
                      }}
                      options={
                        apply?.fetching_keys?.some((v) => v?.value === "all")
                          ? [{ label: "All", value: "all" }]
                          : report
                      }
                    />
                    <small className="validationerror">
                      {validation?.fetching_keys?.message
                        ? `Report Type ${validation?.fetching_keys?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <ReactSelect
                      isMulti={false}
                      value={{
                        label: apply.academic_year,
                        value: apply.academic_year,
                      }}
                      onChange={(selectedOption) =>
                        setData(selectedOption.value, "academic_year")
                      }
                      options={FinancialYearOptions()}
                    />
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  {!IsOldReportYear(apply) && (
                    <div className="col-lg-3">
                      <label className="labeltext"> Month *</label>
                      <ReactSelect
                        isMulti
                        value={apply?.months}
                        onChange={(e) => {
                          setData(e, "months");
                        }}
                        options={
                          apply?.months?.some((v) => v?.value === "all")
                            ? [{ label: "All", value: "all" }]
                            : FinancialMonthOptions(apply)
                        }
                      />
                      <small className="validationerror">
                        {validation?.months?.message
                          ? `Month ${validation?.months?.message}`
                          : ""}
                      </small>
                    </div>
                  )}
                </div>
                <div className="row mt-4">
                  <div className="col-lg-6 mx-auto ms-auto">
                    <div className="row">
                      <div className="col-lg-6 centertext">
                        <button
                          type="submit"
                          className="requestbtn"
                          onClick={(e) => handleSubmit(e)}
                        >
                          Get Report
                        </button>
                      </div>
                      <div className="col-lg-6 centertext">
                        <button
                          type="submit"
                          className="requestbtn"
                          onClick={async () => {
                            let validate = {};
                            validate.employee_ids = NonEmptyValidation(
                              apply?.employee_ids
                            );
                            validate.academic_year = NonEmptyValidation(
                              apply?.academic_year
                            );
                            if (!IsOldReportYear(apply)) {
                              validate.months = NonEmptyValidation(apply?.months);
                            }
                            validate.fetching_keys = NonEmptyValidation(
                              apply?.fetching_keys
                            );

                            setValidation(validate);
                            if (
                              Object.values(validate).every(
                                (v) => v.status === true
                              )
                            ) {
                              const Payload = {
                                ...apply,
                                employee_ids: apply?.employee_ids?.map((date) => date.value),
                                months: apply?.months?.map((date) => date.value),
                                fetching_keys: apply?.fetching_keys?.map((date) => date.value),
                              };
                              const response = await GetDirectorOverallReport(Payload, token);
                              if (response && response.statusCode === 200) {
                                setAppliedReport(response.data);
                                successMsg(response.message);
                                setDownload(true)
                                setTimeout(() => {
                                  setDownload(false)
                                }, 3000);
                                setValidation({});
                              } else {
                                errorMsg(response.message);
                              }
                              // generateWordDocument();
                            }
                          }}
                        >
                          Generate Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <OverallReport
                  appliedReport={appliedReport}
                  isOldReportYear={IsOldReportYearx(apply)}
                  apply={apply}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Directoroverallreport;
